import { ApplicationClientIdentifier, EventBannerReportData } from '@front-app/services/EventsApi/EventDataModel';
import { hashStrings } from '@front-app/util/hash';
import {
	ColumnData,
	EventDataColumn,
	EventDataRow,
	TabulatedEventData,
} from '../Model';

export function toTable(input: EventBannerReportData[]): TabulatedEventData {
	const table: TabulatedEventData = {
		columns: [],
		rows: {},
	};
	const processedColumns: string[] = [];
	input.forEach((val) => {
		const column = toEventDataColumn(val);
		if (!processedColumns.includes(column.columnId)) {
			processedColumns.push(column.columnId);
			table.columns.push(column);
		}
		table.rows[val.date] = assignRowCell(column.columnId, val.count, table.rows[val.date]);
	});
	return table;
}

export function assignRowCell(columnId: string, count: number, currentRow?: EventDataRow): EventDataRow {
	const row: EventDataRow = currentRow || { cells: {} };
	row.cells[columnId] = count;
	return row;
}

function toEventDataColumn(input: EventBannerReportData): EventDataColumn {
	const columnData = {
		action: input.action,
		eventId: input.eventId,
		groupId: input.groupId,
		groupName: input.groupName,
		clientIdentifier: input.clientIdentifier,
		location: input.location,
	};
	return {
		columnId: getColumnId(columnData),
		columnData,
	};
}

export function getColumnId(data: ColumnData): string {
	const hash = hashStrings([
		data.action,
		data.clientIdentifier,
		data.eventId,
		data.groupId || '',
		data.location,
	]);
	return `column_${hash}`;
}

const CLIENT_STR_KEY: Record<ApplicationClientIdentifier, string> = {
	[ApplicationClientIdentifier.PHOENIX]: 'Browser',
	[ApplicationClientIdentifier.TRAPP]: 'Browser',
	[ApplicationClientIdentifier.IOS_APP]: 'iOS',
};

export function getColumnTitle(data: ColumnData): string {
	const parts = [
		CLIENT_STR_KEY[data.clientIdentifier],
	];
	if (data.groupId && data.groupName) {
		parts.push(data.groupName);
	}
	parts.push(data.location);
	return parts.join(' / ');
}
